import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select';
import currencyCountryMap2 from './currencyCountryMap2';
import close from '../Components/Images/x-close.png';
import { Context } from '../Context/Context';
// import AcctModal from './AcctModal';

const CreateAcctBar = ({ setAcctModal, setAcctErrorModal }) => {

    const { acctBar, handleAcctBar, fetchAccountsAndWalletData, setSelectedCurrency, selectedCurrency } = useContext(Context)


    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        currency: ''
    })

    const createAccount = async (e) => {
        e.preventDefault();

        const error = {};

        if (!selectedCurrency || !selectedCurrency.value) {
            error.selectedCurrency = 'Please select a currency!';
        }

        if (Object.keys(error).length > 0) {
            setErrors(error);
            return;
        }

        setErrors({});
        setIsSubmitting(true);

        try {
            const token = localStorage.getItem('token');

            const isValidToken =
                token && token !== 'undefined' && token !== 'null' && token !== '';

            if (!isValidToken) {
                throw new Error('Invalid or missing token. Please log in again.');
            }

            const response = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/account`,
                {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Token ${token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                }
            );

            const data = await response.json();

            if (!response.ok) {
                console.log('API call failed:', data);
                setAcctErrorModal(true);
                handleAcctBar();
                return; // stop here
            }

            // ✅ SUCCESS
            console.log('API success:', data);

            setAcctModal(true);
            window.scrollTo(0, 0);
            handleAcctBar();

            // 🔑 Read previous count
            const previousAcctCount =
                Number(localStorage.getItem('NumberOfUserAcct')) || 0;

            // 🔑 Update localStorage immediately
            const newAcctCount = previousAcctCount + 1;
            localStorage.setItem('NumberOfUserAcct', newAcctCount);

            // 🔁 Control flow
            if (previousAcctCount === 0) {
                // first-ever account → full remount so Home switches view
                window.location.reload();
            } else {
                // already had accounts → just refresh data
                fetchAccountsAndWalletData();
            }
        } catch (error) {
            console.error('Error during account creation:', error.message);
            setAcctErrorModal(true);
            handleAcctBar();
        } finally {
            setIsSubmitting(false);
        }
    };



    const allowedCurrencies = ['USD', 'EUR'];

    const currencyOptions = Object.keys(currencyCountryMap2)
        .filter(code => allowedCurrencies.includes(code))
        .map(code => {
            const countryCode = currencyCountryMap2[code];
            return {
                value: code,
                label: (
                    <div className="flex items-center gap-2">
                        <img
                            src={`https://flagcdn.com/w40/${countryCode}.png`}
                            alt={code}
                            className="w-[20px] h-4 rounded-sm"
                        />
                        {code}
                    </div>
                )
            };
        });


    const customStyles = {
        indicatorSeparator: () => ({
            display: 'none',
        }),
        control: (base) => ({
            ...base,
            borderColor: '#F3F0F7',
            borderWidth: '1.2px',
            padding: '4px',
            boxShadow: '0 1px 2px 0 #1D1C1F0D',
            borderRadius: '10px',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#78757A',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 999,
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? '#F3F0F7' : 'white',
            color: 'black',
            padding: 10,
            cursor: 'pointer',
        }),
    };

    const [output, setOutput] = useState("");

    const handleChange = (selectedOption) => {
        setSelectedCurrency(selectedOption);
        if (selectedOption.value) {
            setOutput(`Your ${selectedOption.value} account comes with a unique account number, making it easy to share with anyone sending you payments in ${selectedOption.value}. Enjoy seamless transactions without hidden fees or unfavorable exchange rates.`);
        }
        setFormData(prev => ({
            ...prev,
            currency: selectedOption.value
        }))
        setErrors(prev => ({
            ...prev,
            selectedCurrency: ''
        }))
    };

    useEffect(() => {
        let timeout;

        if (!acctBar) {
            timeout = setTimeout(() => {
                setSelectedCurrency(null)
                setOutput("")
            }, 5200)
        }

        return () => clearTimeout(timeout);
    }, [acctBar, setSelectedCurrency])

    return (
        <div>
            <div className={`fixed lg:top-0 top-[60px] h-screen bg-white z-30 lg:p-10 py-8 px-4 duration-700 ${acctBar ? 'sm:w-[510px] w-full right-0' : 'right-[-100%] w-[40%]'}`}>
                <div className='flex justify-between gap-2'>
                    <div>
                        <h1 className='text-[20px] font-medium text-[#1D1C1F]'>Create Account</h1>
                        <p className='text-[#525154] text-[14px]'>Open a bank account in your preferred country and start receiving payments effortlessly.</p>
                    </div>
                    <img
                        className='size-5 mt-1 cursor-pointer' src={close} alt=""
                        onClick={handleAcctBar}
                    />
                </div>
                <form onSubmit={createAccount} className='mt-7 font-medium text-[14px]'>
                    <label htmlFor="code">Currency</label>
                    <div className='mt-1'>
                        <Select
                            styles={customStyles}
                            options={currencyOptions}
                            onChange={handleChange}
                            value={selectedCurrency}
                            isSearchable={true}
                            className='rounded-m w-full outline-none'
                        />
                        {errors.selectedCurrency && (
                            <p className="text-red-500 text-sm mt-1">{errors.selectedCurrency}</p>
                        )}
                        {output && <p className="mt-1 text-black/70">{output}</p>}
                    </div>
                    <div className='flex gap-2 mt-4'>
                        <button
                            className='p-3 rounded-lg w-[25%] border-[1.2px] border-black/10'
                            onClick={handleAcctBar}
                        >
                            Cancel
                        </button>
                        <button
                            className={`p-[10px] px-4 rounded-lg text-white w-[80%] ${isSubmitting ? 'bg-[#E8E1F5]' : 'bg-[#531CB3]'}`}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? (
                                'Loading...'
                            ) : (
                                'Create Account'
                            )}
                        </button>
                    </div>
                </form>
            </div>
            {/* <AcctModal selectedCurrency={selectedCurrency} openAcctModal={openAcctModal} setAcctModal={setAcctModal} AcctErrorModal={AcctErrorModal} setAcctErrorModal={setAcctErrorModal} /> */}
        </div>
    )
}

export default CreateAcctBar